// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "uuid";
import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as JsxPPXReactSupportU from "rescript/lib/es6/jsxPPXReactSupportU.js";
import * as Lang$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Lang.res.mjs";
import * as Wrap$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Wrap.res.mjs";
import * as Error$LiteracyplanetClientErrors from "@literacyplanet/client-errors/src/Error.res.mjs";
import * as Lazy$LiteracyplanetClientSxEntry from "./Lazy.res.mjs";
import * as Option2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Option2.res.mjs";
import * as NoMatch$LiteracyplanetClientSxEntry from "./NoMatch.res.mjs";
import * as HasuraTypes$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/HasuraTypes.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as RouteContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/RouteContext.res.mjs";
import * as InMemoryStore$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/InMemoryStore.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as MobileUtils$LiteracyplanetClientSxEntry from "./MobileUtils.res.mjs";
import * as ProRequired$LiteracyplanetClientSxEntry from "./ProRequired.res.mjs";
import * as CobraContainer$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/CobraContainer.res.mjs";
import * as SeenBeforeQuery$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SeenBeforeQuery.res.mjs";
import * as StoryverseIntro$LiteracyplanetClientSxEntry from "./book_of_goings/StoryverseIntro.res.mjs";
import * as AwardBadgesHooks$LiteracyplanetClientSxEntry from "./profile/AwardBadgesHooks.res.mjs";
import * as ChecksLobbyQuery$LiteracyplanetClientSxEntry from "./checks/ChecksLobbyQuery.res.mjs";
import * as ProfileContainer$LiteracyplanetClientSxEntry from "./profile/ProfileContainer.res.mjs";
import * as SeenBeforeMutation$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SeenBeforeMutation.res.mjs";
import * as BackgroundChanger$LiteracyplanetClientSxEntry from "./BackgroundChanger.res.mjs";
import * as BogTabSerialisation$LiteracyplanetClientSxEntry from "./book_of_goings/BogTabSerialisation.res.mjs";
import * as JourneyMissionsQuery$LiteracyplanetClientSxEntry from "./JourneyMissionsQuery.res.mjs";
import * as ProfileAvatarContext$LiteracyplanetClientSxEntry from "./profile/ProfileAvatarContext.res.mjs";
import * as AcademyIndexContainer$LiteracyplanetClientSxEntry from "./academy/AcademyIndexContainer.res.mjs";
import * as JourneyCurrentStudent$LiteracyplanetClientSxEntry from "./JourneyCurrentStudent.res.mjs";
import * as JourneyActivitiesQuery$LiteracyplanetClientSxEntry from "./JourneyActivitiesQuery.res.mjs";
import * as JourneyActivitiesScreen$LiteracyplanetClientSxEntry from "./JourneyActivitiesScreen.res.mjs";
import * as DeepLinkActivitiesScreen$LiteracyplanetClientSxEntry from "./DeepLinkActivitiesScreen.res.mjs";
import * as WordFlyersIndexContainer$LiteracyplanetClientSxEntry from "./word_flyers/WordFlyersIndexContainer.res.mjs";
import * as FlipperAcademyLauncher$LiteracyplanetClientSxActivity from "@literacyplanet/client-sx-activity/src/flipper/FlipperAcademyLauncher.res.mjs";
import * as FlipperChecksActivityLauncher$LiteracyplanetClientSxActivity from "@literacyplanet/client-sx-activity/src/flipper/FlipperChecksActivityLauncher.res.mjs";

function vodFolder(video) {
  return "$videoFolder/$video/Default/HLS/$video.m3u8";
}

function devPrefix(isDev, name) {
  return (
          isDev ? "dev_" : ""
        ) + name;
}

function source(isDev, videoName) {
  devPrefix(isDev, videoName);
  return "$videoFolder/$video/Default/HLS/$video.m3u8";
}

function Page$StoryverseIntroCheck(props) {
  var redirect = props.redirect;
  FlagsContext$LiteracyplanetClientFlags.use();
  var redirectStoryverseIntro = function (param) {
    redirect("StoryverseIntro");
  };
  var redirectChecksLobby = function (param) {
    redirect("ChecksLobby");
  };
  var seenBefore = SeenBeforeQuery$LiteracyplanetClientFlags.useCurrentUser();
  React.useEffect((function () {
          SeenBeforeQuery$LiteracyplanetClientFlags.hasSeenType(seenBefore, "STORYVERSE_INTRO", redirectChecksLobby, redirectStoryverseIntro);
        }), [seenBefore]);
  return null;
}

var StoryverseIntroCheck = {
  make: Page$StoryverseIntroCheck
};

function Page$StudentExperience(props) {
  var redirect = props.redirect;
  var whatExperience = Wrap$LiteracyplanetClientFlags.useStudentExperience();
  React.useEffect((function () {
          if (whatExperience === "Secondary") {
            redirect("ChecksLobby");
          }
          
        }), []);
  if (whatExperience === "Secondary") {
    return null;
  } else {
    return React.createElement(Page$StoryverseIntroCheck, {
                redirect: redirect
              });
  }
}

var StudentExperience = {
  make: Page$StudentExperience
};

function Page$StudentCollections(props) {
  var isPageBlacklisted = props.isPageBlacklisted;
  var redirect = props.redirect;
  FlagsContext$LiteracyplanetClientFlags.use();
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var onClickShop = function (param) {
    redirect("AvatarShop");
  };
  var onClickArcade = function (param) {
    redirect("Arcade");
  };
  var isShopLocked = isPageBlacklisted("AvatarShop");
  var isArcadeLocked = isPageBlacklisted("Arcade");
  var isMiniGameLocked = props.isItemBlacklisted("MiniGame");
  var isProRequired = ProRequired$LiteracyplanetClientSxEntry.use();
  var key = "locked-" + (
    isShopLocked ? "true" : "false"
  );
  return React.createElement(React.Suspense, {
              children: Caml_option.some(JsxPPXReactSupportU.createElementWithKey(key, Lazy$LiteracyplanetClientSxEntry.CollectionsContainer.make, {
                        userId: userId,
                        onClickShop: onClickShop,
                        onClickArcade: onClickArcade,
                        isShopLocked: isShopLocked,
                        isArcadeLocked: isArcadeLocked,
                        isMiniGameLocked: isMiniGameLocked,
                        onToggleProModal: props.onToggleProModal,
                        onToggleLockedModal: props.onToggleLockedModal,
                        isProRequiredForMiniGame: isProRequired("MiniGame")
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var StudentCollections = {
  make: Page$StudentCollections
};

function Page$StudentLibrary(props) {
  var redirect = props.redirect;
  var defaultGroupIndex = Belt_Option.mapWithDefault(props.groupIndex, 0, Caml_format.int_of_string);
  var onChangeBookId = function (bookId) {
    redirect({
          TAG: "StudentLibrary",
          _0: String(defaultGroupIndex),
          _1: bookId
        });
  };
  var onChangeGroupIndex = function (groupIndex) {
    redirect({
          TAG: "StudentLibrary",
          _0: String(groupIndex),
          _1: undefined
        });
  };
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.Library.make, {
                        bookId: props.bookId,
                        groupIndex: defaultGroupIndex,
                        onChangeBookId: onChangeBookId,
                        onChangeGroupIndex: onChangeGroupIndex
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var StudentLibrary = {
  make: Page$StudentLibrary
};

function Page$SecondaryMissions(props) {
  var state = props.state;
  var redirectWithState = props.redirectWithState;
  var redirect = props.redirect;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var completedFilter = Belt_Option.mapWithDefault(Js_dict.get(state, "completed"), false, (function (p) {
          return p === "true";
        }));
  React.useEffect((function () {
          var match = hasFlag("StudentHasSecondary");
          if (match) {
            
          } else if (completedFilter) {
            redirect("OverviewReport");
          } else {
            redirect("JourneyMissions");
          }
        }), []);
  var onClickCompletedFilter = function (_filter) {
    if (completedFilter) {
      Js_dict.unsafeDeleteKey(state, "completed");
    } else {
      state["completed"] = "true";
    }
    redirectWithState({
          TAG: "SecondaryMissions",
          _0: undefined
        }, state);
  };
  var value_onClickActivity = function (studentActivityId, locale, accent) {
    redirect({
          TAG: "StudentActivity",
          _0: locale,
          _1: accent,
          _2: studentActivityId
        });
  };
  var value = {
    onClickActivity: value_onClickActivity,
    onClickMissionFilter: onClickCompletedFilter
  };
  return React.createElement(RouteContext$LiteracyplanetClientFlags.Missions.make, {
              value: value,
              children: React.createElement(React.Suspense, {
                    children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.SecondaryMissions.make, {
                              completed: completedFilter
                            })),
                    fallback: Caml_option.some(React.createElement("div", undefined))
                  })
            });
}

var SecondaryMissions = {
  make: Page$SecondaryMissions
};

function Page$Activity(props) {
  var redirect = props.redirect;
  var isPageBlacklisted = props.isPageBlacklisted;
  var onToggleLocked = props.onToggleLocked;
  var user = UserContext$LiteracyplanetClientFlags.use();
  var onMaybeGotoCollections = function (callback) {
    if (isPageBlacklisted("StudentCollections")) {
      return onToggleLocked();
    } else {
      return callback(redirect("StudentCollections"));
    }
  };
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.FlipperActivity.make, {
                        userId: user.userId,
                        onMaybeGotoCollections: onMaybeGotoCollections,
                        onActivityNotFound: props.onActivityNotFound,
                        onGoToMissions: props.onGoToMissions,
                        onExit: props.onExit,
                        studentActivityId: props.studentActivityId,
                        accent: Lang$LiteracyplanetClientFlags.decodeAccent(props.accent),
                        locale: Lang$LiteracyplanetClientFlags.decodeLocale(props.locale)
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var Activity = {
  make: Page$Activity
};

function Page$StudentActivity(props) {
  var onGoToMissions = props.onGoToMissions;
  return React.createElement(Page$Activity, {
              onGoToMissions: onGoToMissions,
              onActivityNotFound: onGoToMissions,
              onToggleLocked: props.onToggleLocked,
              isPageBlacklisted: props.isPageBlacklisted,
              redirect: props.redirect,
              onExit: onGoToMissions,
              locale: props.locale,
              accent: props.accent,
              studentActivityId: props.studentActivityId
            });
}

var StudentActivity = {
  make: Page$StudentActivity
};

function Page$PlayAnyActivity(props) {
  var goBack = props.goBack;
  FlagsContext$LiteracyplanetClientFlags.use();
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.FlipperPlayAnyActivity.make, {
                        contentId: props.contentId,
                        contentVersion: props.contentVersion,
                        contentKind: props.contentKind,
                        kind: props.kind,
                        locale: Lang$LiteracyplanetClientFlags.decodeLocale(props.locale),
                        accent: Lang$LiteracyplanetClientFlags.decodeAccent(props.accent),
                        title: Js_dict.get(props.state, "title"),
                        onExit: (function () {
                            goBack();
                          }),
                        onGoToMissions: (function () {
                            goBack();
                          }),
                        onMaybeGotoCollections: (function (callback) {
                            callback();
                          })
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var PlayAnyActivity = {
  make: Page$PlayAnyActivity
};

function Page$AvatarShop(props) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var isProRequired = ProRequired$LiteracyplanetClientSxEntry.use();
  var isProAccessLocked = isProRequired("AvatarShop");
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.AvatarShop.make, {
                        userId: userId,
                        isProAccessLocked: isProAccessLocked,
                        onExit: props.onGoToMissions
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var AvatarShop = {
  make: Page$AvatarShop
};

function Page$StoryverseIntro(props) {
  var redirect = props.redirect;
  var markSeenBefore = SeenBeforeMutation$LiteracyplanetClientFlags.useSeenBeforeWithUser("STORYVERSE_INTRO");
  var onExit = function (param) {
    markSeenBefore();
    redirect("ChecksLobby");
  };
  return React.createElement(StoryverseIntro$LiteracyplanetClientSxEntry.make, {
              onExit: onExit
            });
}

var StoryverseIntro = {
  make: Page$StoryverseIntro
};

function Page$Bog(props) {
  var redirectWithState = props.redirectWithState;
  var state = props.state;
  var redirect = props.redirect;
  var onChangeNavigation = function (nav) {
    state["nav"] = BogTabSerialisation$LiteracyplanetClientSxEntry.encode(nav);
    redirectWithState("Bog", state);
  };
  var onExit = function (param) {
    redirect("JourneyMissions");
  };
  var nav = Belt_Option.mapWithDefault(Js_dict.get(state, "nav"), "BogDefault", (function (nav) {
          return BogTabSerialisation$LiteracyplanetClientSxEntry.decode(nav);
        }));
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.BogContainer.make, {
                        onExit: onExit,
                        onChangeNavigation: onChangeNavigation,
                        nav: nav
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var Bog = {
  make: Page$Bog
};

function Page$JourneyMissions$Render(props) {
  var redirect = props.redirect;
  var match = BackgroundChanger$LiteracyplanetClientSxEntry.use();
  var setBackground = match[1];
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var hasSecondary = hasFlag("StudentHasSecondary");
  LocaleContext$LiteracyplanetClientFlags.use();
  var missionStates = JourneyMissionsQuery$LiteracyplanetClientSxEntry.useCurrentUser(props.avatarUserIds);
  var user = UserContext$LiteracyplanetClientFlags.use();
  var myUserId = user.userId;
  var match$1 = React.useState(function () {
        
      });
  var setProfileUserId = match$1[1];
  var profileUserId = match$1[0];
  var resetProfile = function (param) {
    setProfileUserId(function (param) {
          
        });
  };
  var onMyProfile = function (param) {
    setProfileUserId(function (param) {
          return myUserId;
        });
  };
  var onOtherProfile = function (userId) {
    setProfileUserId(function (param) {
          return userId.userID;
        });
  };
  var isMe = Caml_obj.equal(myUserId, profileUserId);
  var match$2 = Error$LiteracyplanetClientErrors.Consumer.use();
  var onSetError = match$2.onSetError;
  JourneyActivitiesQuery$LiteracyplanetClientSxEntry.setReferrerOnLoad("mission");
  var showWordManiaLink = hasFlag("StudentCanAccessWM");
  var testForActivityAwards = AwardBadgesHooks$LiteracyplanetClientSxEntry.useAwardActivityBadges();
  React.useEffect((function () {
          testForActivityAwards();
        }), []);
  React.useEffect((function () {
          if (hasSecondary) {
            redirect({
                  TAG: "SecondaryMissions",
                  _0: undefined
                });
          }
          
        }), []);
  if (typeof missionStates !== "object") {
    return null;
  }
  var onDispatch = {
    onJourneyMissionSelected: (function (missionId) {
        redirect({
              TAG: "JourneyActivities",
              _0: missionId
            });
      }),
    onPreloaderReady: (function (c) {
        setBackground(function (param) {
              return c.backgroundColor;
            });
      }),
    onJourneyReady: (function (c) {
        setBackground(function (param) {
              return c.backgroundColor;
            });
      }),
    onJourneyShowMyProfile: onMyProfile,
    onJourneyShowAnotherStudentsProfile: onOtherProfile,
    onFailed: (function (err) {
        onSetError(Error$LiteracyplanetClientErrors.JsInterop.makeError("JourneyMissionsError", err));
      }),
    onGoToWordMania: showWordManiaLink ? (function (param) {
          MobileUtils$LiteracyplanetClientSxEntry.openWordMania();
        }) : undefined
  };
  return React.createElement("div", {
              style: match[0]
            }, React.createElement(CobraContainer$LiteracyplanetClientFlags.make, {
                  view: "jms",
                  props: missionStates._0,
                  onDispatch: onDispatch
                }), hasFlag("FeatStudentProfile") ? React.createElement(ProfileContainer$LiteracyplanetClientSxEntry.make, {
                    userId: profileUserId,
                    isMe: isMe,
                    resetProfile: resetProfile
                  }) : null);
}

var Render = {
  make: Page$JourneyMissions$Render
};

function Page$JourneyMissions(props) {
  var redirect = props.redirect;
  return React.createElement(ProfileAvatarContext$LiteracyplanetClientSxEntry.make, {
              loading: null,
              children: (function (avatarUserIds) {
                  return React.createElement(Page$JourneyMissions$Render, {
                              redirect: redirect,
                              avatarUserIds: avatarUserIds
                            });
                })
            });
}

var JourneyMissions = {
  Render: Render,
  make: Page$JourneyMissions
};

function Page$JourneyActivities(props) {
  return React.createElement(JourneyActivitiesScreen$LiteracyplanetClientSxEntry.make, {
              redirect: props.redirect,
              studentMissionId: Caml_format.int_of_string(props.studentMissionId)
            });
}

var JourneyActivities = {
  make: Page$JourneyActivities
};

function Page$JourneyActivity(props) {
  var isAssessment = props.isAssessment;
  var studentMissionId = props.studentMissionId;
  var redirect = props.redirect;
  var setReferrer = JourneyActivitiesQuery$LiteracyplanetClientSxEntry.referrerSetter();
  var onGoToMissions = function (param) {
    setReferrer("activityComplete");
    if (isAssessment) {
      return redirect("JourneyMissions");
    } else {
      return redirect({
                  TAG: "JourneyActivities",
                  _0: studentMissionId
                });
    }
  };
  var onExit = function (param) {
    setReferrer("activityAbort");
    redirect({
          TAG: "JourneyActivities",
          _0: studentMissionId
        });
  };
  return React.createElement(Page$Activity, {
              onGoToMissions: onGoToMissions,
              onActivityNotFound: onGoToMissions,
              onToggleLocked: props.onToggleLocked,
              isPageBlacklisted: props.isPageBlacklisted,
              redirect: redirect,
              onExit: onExit,
              locale: props.locale,
              accent: props.accent,
              studentActivityId: props.studentActivityId
            });
}

var JourneyActivity = {
  make: Page$JourneyActivity
};

function Page$TupperwareDemo(props) {
  return null;
}

var TupperwareDemo = {
  make: Page$TupperwareDemo
};

function Page$Arcade(props) {
  var redirect = props.redirect;
  var onClickGame = function (gameName) {
    redirect({
          TAG: "ArcadeGame",
          _0: gameName
        });
  };
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.Arcade.make, {
                        onClickGame: onClickGame
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var Arcade = {
  make: Page$Arcade
};

function Page$ArcadeGame(props) {
  var redirect = props.redirect;
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.localeString;
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var onExit = function (param) {
    redirect("Arcade");
  };
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.ArcadeGame.make, {
                        onExit: onExit,
                        locale: locale,
                        gameKind: props.gameKind,
                        userId: userId
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var ArcadeGame = {
  make: Page$ArcadeGame
};

function Page$WordManiaGame(props) {
  var redirect = props.redirect;
  var onExit = function (param) {
    redirect("Arcade");
  };
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.WordManiaGame.make, {
                        onExit: onExit
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var WordManiaGame = {
  make: Page$WordManiaGame
};

function Page$AcademyIndex(props) {
  var redirectWithState = props.redirectWithState;
  var md5 = props.md5;
  var onPlayActivity = function (id, title) {
    redirectWithState({
          TAG: "AcademyActivity",
          academyActivityId: id,
          md5: md5
        }, Js_dict.fromList({
              hd: [
                "title",
                title
              ],
              tl: /* [] */0
            }));
  };
  return React.createElement(AcademyIndexContainer$LiteracyplanetClientSxEntry.make, {
              md5: md5,
              onPlayActivity: onPlayActivity
            });
}

var AcademyIndex = {
  make: Page$AcademyIndex
};

function launcher(props) {
  return FlipperAcademyLauncher$LiteracyplanetClientSxActivity.make(props);
}

function Page$AcademyActivity(props) {
  var redirect = props.redirect;
  var id = props.id;
  var md5 = props.md5;
  var onBack = function (param) {
    redirect({
          TAG: "AcademyIndex",
          md5: md5,
          returnFromActivityId: id
        });
  };
  var title = Belt_Option.getWithDefault(Js_dict.get(props.state, "title"), "Literacy Planet");
  return React.createElement(launcher, {
              id: id,
              onBack: onBack,
              title: title,
              source: "ACADEMY"
            });
}

var AcademyActivity = {
  launcher: launcher,
  make: Page$AcademyActivity
};

function Page$MyWordsLists(props) {
  var state = props.state;
  var replaceWithState = props.replaceWithState;
  var redirect = props.redirect;
  var onNewList = function (param) {
    redirect({
          TAG: "MyWordsNew",
          _0: Uuid.v4()
        });
  };
  var onEditList = function (id) {
    redirect({
          TAG: "MyWordsAssign",
          _0: id
        });
  };
  var onSetPage = function (page) {
    state["page"] = String(page);
    replaceWithState("MyWordsLists", state);
  };
  var page = Belt_Option.mapWithDefault(Js_dict.get(state, "page"), 1, Caml_format.int_of_string);
  var searchName = Js_dict.get(state, "searchName");
  var onSearchName = function (name) {
    if (name === "") {
      Js_dict.unsafeDeleteKey(state, "searchName");
    } else {
      state["searchName"] = name;
    }
    state["page"] = "1";
    replaceWithState("MyWordsLists", state);
  };
  var testForActivityAwards = AwardBadgesHooks$LiteracyplanetClientSxEntry.useAwardActivityBadges();
  React.useEffect((function () {
          testForActivityAwards();
        }), []);
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.MyWordsIndexContainer.make, {
                        onNewList: onNewList,
                        onEditList: onEditList,
                        onSetPage: onSetPage,
                        page: page,
                        searchName: searchName,
                        onSearchName: onSearchName
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var MyWordsLists = {
  make: Page$MyWordsLists
};

function Page$MyWordsAssign(props) {
  var id = props.id;
  var redirect = props.redirect;
  var onBack = function (param) {
    redirect("MyWordsLists");
  };
  var onEditList = function (param) {
    redirect({
          TAG: "MyWordsEdit",
          _0: id
        });
  };
  var onPlayActivity = function (kind) {
    redirect({
          TAG: "MyWordsActivity",
          _0: id,
          _1: kind
        });
  };
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.MyWordsAssignContainer.make, {
                        onBack: onBack,
                        onEditList: onEditList,
                        onPlayActivity: onPlayActivity,
                        customWordListId: id,
                        userId: userId
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var MyWordsAssign = {
  make: Page$MyWordsAssign
};

function Page$MyWordsEdit(props) {
  var redirect = props.redirect;
  var id = props.id;
  var onBack = function (param) {
    redirect({
          TAG: "MyWordsAssign",
          _0: id
        });
  };
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.MyWordsEditContainer.make, {
                        onBack: onBack,
                        onSave: onBack,
                        customWordListId: id,
                        userId: userId
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var MyWordsEdit = {
  make: Page$MyWordsEdit
};

function Page$MyWordsNew(props) {
  var redirect = props.redirect;
  var id = props.id;
  var onBack = function (param) {
    redirect("MyWordsLists");
  };
  var onSave = function (param) {
    redirect({
          TAG: "MyWordsAssign",
          _0: id
        });
  };
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.MyWordsEditContainer.make, {
                        onBack: onBack,
                        onSave: onSave,
                        customWordListId: id,
                        userId: userId
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var MyWordsNew = {
  make: Page$MyWordsNew
};

function Page$MyWordsActivity(props) {
  var redirect = props.redirect;
  var id = props.id;
  var onBack = function (param) {
    redirect({
          TAG: "MyWordsAssign",
          _0: id
        });
  };
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.MyWordsActivityContainer.make, {
                        gameId: props.gameId,
                        onBack: onBack,
                        customWordListId: id
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var MyWordsActivity = {
  make: Page$MyWordsActivity
};

function Page$ChecksLobby$LcLobby(props) {
  var match = BackgroundChanger$LiteracyplanetClientSxEntry.use();
  var setBackground = match[1];
  var match$1 = Error$LiteracyplanetClientErrors.Consumer.use();
  var onSetError = match$1.onSetError;
  var onDispatch = {
    onJourneyActivitySelected: props.redirectChecksActivity,
    onExit: (function (param) {
        
      }),
    onPreloaderReady: (function (c) {
        setBackground(function (param) {
              return c.backgroundColor;
            });
      }),
    onJourneyReady: (function (c) {
        setBackground(function (param) {
              return c.backgroundColor;
            });
      }),
    onFailed: (function (err) {
        onSetError(Error$LiteracyplanetClientErrors.JsInterop.makeError("JourneyActivitiesError", err));
      }),
    onLogOut: (function (param) {
        MobileUtils$LiteracyplanetClientSxEntry.signOut();
      })
  };
  var makeProps = function (response, currentCheck) {
    return Belt_Option.map(response.currentStudent, (function (s) {
                  return {
                          currentStudent: JourneyCurrentStudent$LiteracyplanetClientSxEntry.makeCurrentStudent(s),
                          activities: Belt_Array.map(response.checks, (function (check) {
                                  return {
                                          id: check.activityId,
                                          kind: check.gameId,
                                          learningMode: {
                                            kind: check.strand,
                                            label: check.strand
                                          },
                                          complete: check.activityComplete,
                                          bestScore: undefined,
                                          inProgress: false,
                                          locked: Caml_obj.notequal(currentCheck.activityId, check.activityId),
                                          assessment: false
                                        };
                                })),
                          mission: {
                            title: "Literacy Check",
                            chest: "GEM"
                          },
                          referrer: "",
                          isLiteracyCheck: true
                        };
                }));
  };
  return React.createElement("div", {
              style: match[0]
            }, React.createElement(CobraContainer$LiteracyplanetClientFlags.make, {
                  view: "jas",
                  props: makeProps(props.res, props.currentCheck),
                  onDispatch: onDispatch
                }));
}

var LcLobby = {
  make: Page$ChecksLobby$LcLobby
};

function Page$ChecksLobby$LcAssignmentComplete(props) {
  var match = BackgroundChanger$LiteracyplanetClientSxEntry.use();
  var setBackground = match[1];
  var onDispatch = {
    onResultReady: (function (param) {
        
      }),
    onExit: props.redirectJourneyMissions,
    onPreloaderReady: (function (c) {
        setBackground(function (param) {
              return c.backgroundColor;
            });
      })
  };
  return React.createElement("div", {
              style: match[0]
            }, React.createElement(CobraContainer$LiteracyplanetClientFlags.make, {
                  view: "literacyCheckComplete",
                  props: {
                    results: {
                      title: "Literacy Check"
                    }
                  },
                  onDispatch: onDispatch
                }));
}

var LcAssignmentComplete = {
  make: Page$ChecksLobby$LcAssignmentComplete
};

function Page$ChecksLobby$RedirectComponent(props) {
  var dest = props.dest;
  React.useEffect((function () {
          dest();
        }), []);
  return null;
}

var RedirectComponent = {
  make: Page$ChecksLobby$RedirectComponent
};

function Page$ChecksLobby$MarkAssignationCompleteWhenAllActivitiesAreComplete(props) {
  return React.createElement(React.Fragment, {}, Belt_Option.mapWithDefault(Belt_Array.reduce(props.checks, undefined, (function (acc, c) {
                        return Option2$LiteracyplanetClientFlags.combine(c.assignationId, Belt_Option.map(c.studentActivityAttemptId, HasuraTypes$LiteracyplanetClientFlags.decode));
                      })), null, (function (param) {
                    return React.createElement(FlipperChecksActivityLauncher$LiteracyplanetClientSxActivity.MarkCompleteWhenAllComplete.make, {
                                assignationId: param[0],
                                studentActivityAttemptId: param[1]
                              });
                  })), React.createElement(Page$ChecksLobby$RedirectComponent, {
                  dest: props.dest
                }));
}

var MarkAssignationCompleteWhenAllActivitiesAreComplete = {
  make: Page$ChecksLobby$MarkAssignationCompleteWhenAllActivitiesAreComplete
};

function Page$ChecksLobby(props) {
  var onGoToMissions = props.onGoToMissions;
  var redirect = props.redirect;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var hasLC = hasFlag("ProductStudentHasLiteracyCheck");
  var setInMemory = InMemoryStore$LiteracyplanetClientFlags.useSetter();
  var redirectJourneyMissions = function (param) {
    setInMemory("ranLcActivity", "false");
    onGoToMissions();
  };
  var redirectChecksActivity = function (activityId) {
    return redirect("ChecksActivity");
  };
  var userComingBackFromActivity = Belt_Option.getWithDefault(Belt_Option.map(InMemoryStore$LiteracyplanetClientFlags.useGetter("ranLcActivity"), (function (v) {
              return v === "true";
            })), false);
  React.useEffect((function () {
          if (hasLC) {
            
          } else {
            redirectJourneyMissions();
          }
        }), []);
  var state = ChecksLobbyQuery$LiteracyplanetClientSxEntry.use(!hasLC);
  if (typeof state !== "object") {
    return null;
  }
  var res = state._0;
  var currentCheck = Belt_Array.getBy(res.checks, (function (c) {
          return Caml_obj.equal(c.activityComplete, false);
        }));
  if (currentCheck !== undefined) {
    return React.createElement(Page$ChecksLobby$LcLobby, {
                redirectChecksActivity: redirectChecksActivity,
                redirectJourneyMissions: redirectJourneyMissions,
                res: res,
                currentCheck: currentCheck
              });
  } else if (userComingBackFromActivity) {
    return React.createElement(Page$ChecksLobby$LcAssignmentComplete, {
                redirectJourneyMissions: redirectJourneyMissions
              });
  } else {
    return React.createElement(Page$ChecksLobby$MarkAssignationCompleteWhenAllActivitiesAreComplete, {
                checks: res.checks,
                dest: redirectJourneyMissions
              });
  }
}

var ChecksLobby = {
  LcLobby: LcLobby,
  LcAssignmentComplete: LcAssignmentComplete,
  RedirectComponent: RedirectComponent,
  MarkAssignationCompleteWhenAllActivitiesAreComplete: MarkAssignationCompleteWhenAllActivitiesAreComplete,
  make: Page$ChecksLobby
};

function Page$OverviewReport(props) {
  var redirectWithState = props.redirectWithState;
  var user = UserContext$LiteracyplanetClientFlags.use();
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  React.useEffect((function () {
          if (hasFlag("StudentHasSecondary")) {
            redirectWithState({
                  TAG: "SecondaryMissions",
                  _0: undefined
                }, Js_dict.fromArray([[
                        "completed",
                        "true"
                      ]]));
          }
          
        }), []);
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.OverviewReportContainer.make, {
                        userId: userId
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var OverviewReport = {
  make: Page$OverviewReport
};

function Page$ChecksActivity(props) {
  var redirect = props.redirect;
  var onBack = function (param) {
    redirect("ChecksLobby");
  };
  return React.createElement(React.Suspense, {
              children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.ChecksActivityContainer.make, {
                        onBack: onBack
                      })),
              fallback: Caml_option.some(React.createElement("div", undefined))
            });
}

var ChecksActivity = {
  make: Page$ChecksActivity
};

function Page$Intrepizine(props) {
  var state = props.state;
  var pageToUrlWithState = props.pageToUrlWithState;
  var postUrl = function (postId, title) {
    state["title"] = title;
    return pageToUrlWithState({
                TAG: "Intrepizine",
                _0: postId
              }, state);
  };
  var indexUrl = function () {
    return pageToUrlWithState({
                TAG: "Intrepizine",
                _0: undefined
              }, {});
  };
  var postTitle = Belt_Option.getWithDefault(Js_dict.get(state, "title"), "Article");
  return React.createElement("div", {
              className: "sx-iz"
            }, React.createElement(React.Suspense, {
                  children: Caml_option.some(React.createElement(Lazy$LiteracyplanetClientSxEntry.IntrepizineContainer.make, {
                            optionalPostId: props.optionalPostId,
                            postUrl: postUrl,
                            indexUrl: indexUrl,
                            postTitle: postTitle
                          })),
                  fallback: Caml_option.some(React.createElement("div", undefined))
                }));
}

var Intrepizine = {
  make: Page$Intrepizine
};

function Page$DeepLinkActivities(props) {
  return React.createElement(DeepLinkActivitiesScreen$LiteracyplanetClientSxEntry.make, {
              redirect: props.redirect,
              missionRef: props.missionRef
            });
}

var DeepLinkActivities = {
  make: Page$DeepLinkActivities
};

function Page$DeepLinkActivitiesNotFound(props) {
  return React.createElement(NoMatch$LiteracyplanetClientSxEntry.make, {
              children: "Sorry, we can't find any matching activities!"
            });
}

var DeepLinkActivitiesNotFound = {
  make: Page$DeepLinkActivitiesNotFound
};

function Page$WordFlyersIndex(props) {
  var onGoToMissions = props.onGoToMissions;
  var redirectWithState = props.redirectWithState;
  var redirect = props.redirect;
  var onMenuClick = function (optJourney, optGate) {
    redirect({
          TAG: "WordFlyersIndex",
          _0: optJourney,
          _1: optGate
        });
  };
  var onActivityClick = function (journey, gate, id, title) {
    redirectWithState({
          TAG: "WordFlyersActivity",
          _0: journey,
          _1: gate,
          _2: id
        }, Js_dict.fromList({
              hd: [
                "title",
                title
              ],
              tl: /* [] */0
            }));
  };
  return React.createElement(WordFlyersIndexContainer$LiteracyplanetClientSxEntry.make, {
              optionalJourney: props.optionalJourney,
              optionalGate: props.optionalGate,
              onBack: (function (param) {
                  onGoToMissions();
                }),
              onActivityClick: onActivityClick,
              onMenuClick: onMenuClick
            });
}

var WordFlyersIndex = {
  make: Page$WordFlyersIndex
};

function launcher$1(props) {
  return FlipperAcademyLauncher$LiteracyplanetClientSxActivity.make(props);
}

function Page$WordFlyersActivity(props) {
  var redirect = props.redirect;
  var gate = props.gate;
  var journey = props.journey;
  var title = Belt_Option.getWithDefault(Js_dict.get(props.state, "title"), "");
  var onBack = function (param) {
    redirect({
          TAG: "WordFlyersIndex",
          _0: journey,
          _1: gate
        });
  };
  return React.createElement(launcher$1, {
              id: props.id,
              onBack: onBack,
              title: title,
              source: "WORD_FLYERS"
            });
}

var WordFlyersActivity = {
  launcher: launcher$1,
  make: Page$WordFlyersActivity
};

var videoFolder = "https://vod-watchfolder-literacyplanet.s3-ap-southeast-2.amazonaws.com";

export {
  videoFolder ,
  vodFolder ,
  devPrefix ,
  source ,
  StoryverseIntroCheck ,
  StudentExperience ,
  StudentCollections ,
  StudentLibrary ,
  SecondaryMissions ,
  Activity ,
  StudentActivity ,
  PlayAnyActivity ,
  AvatarShop ,
  StoryverseIntro ,
  Bog ,
  JourneyMissions ,
  JourneyActivities ,
  JourneyActivity ,
  TupperwareDemo ,
  Arcade ,
  ArcadeGame ,
  WordManiaGame ,
  AcademyIndex ,
  AcademyActivity ,
  MyWordsLists ,
  MyWordsAssign ,
  MyWordsEdit ,
  MyWordsNew ,
  MyWordsActivity ,
  ChecksLobby ,
  OverviewReport ,
  ChecksActivity ,
  Intrepizine ,
  DeepLinkActivities ,
  DeepLinkActivitiesNotFound ,
  WordFlyersIndex ,
  WordFlyersActivity ,
}
/* uuid Not a pure module */
